<template>
    <div class="banner" id="swipercom"  @mouseenter="mouseenter"  @mouseleave="mouseleave">
        <div class="swiper-container" id="swiperIndex">
            <div class="swiper-wrapper">
                <div class="swiper-slide slider_img" v-for="(item,i) in $route.query.ys?sliders2:sliders" :key="i" :style="('background-image:url('+item.img+')' )" >
                     <div class="overlay" v-if="i===1">
                         <div class="text">
                           <h2>热烈祝贺</h2>
                           <p> 鼎函科技通过国家高新技术企业认定</p>
                         </div>
                     </div>
                </div>
            </div>
            <!-- //换页器 -->
            <div class="swiper-pagination">
 
            </div>
            <!-- //前进后退 -->
            <div  class="swiper-button-next swiper-button-white"></div>
            <div  class="swiper-button-prev swiper-button-white"></div>
            <!-- //滚动条 -->
            <!-- <div class="swiper-scrollbar"></div> -->
        </div>
    </div>
</template>
<script >
import 'swiper/css/swiper.css' 
import Swiper from 'swiper';    //引入swiper
var mySwiper
    export default {
        name: 'banner',
        data() {
            return {
              sliders: [
                {
                  img: 'https://dh-policy-bucket.obs.cn-east-3.myhuaweicloud.com/www/bg15.jpg',
                  text:''

                },
                {
                  // img: 'https://dh-policy-bucket.obs.cn-east-3.myhuaweicloud.com/www/bg17.jpg',
                  img: require('../../static/other/banner04.jpg'),
                  text:''

                }
              ],
                spec: {
                    img: require('../../static/other/arrow.png'),
                },
                carousel_height: '800px',
                mouseIn:false,
             
            }
        },
        methods: {
            mouseenter(){
                mySwiper.navigation.$nextEl.css('display','block');
                mySwiper.navigation.$prevEl.css('display','block');
            },
            mouseleave(){
                mySwiper.navigation.$nextEl.css('display','none');
                mySwiper.navigation.$prevEl.css('display','none');
                
                
            }
        },
        mounted() {
            new this.$wow.WOW().init()
            mySwiper = new Swiper('#swiperIndex',{
                //配置分页器内容
 
                loop: true, // 循环模式选项
                pagination:{
                    el:".swiper-pagination",//换页器与哪个标签关联
                    clickable:true,//分页器是否可以点击
                    dynamicBullets: true,
                },
                navigation: {
                nextEl: '.swiper-button-next',
                prevEl: '.swiper-button-prev',
                },
				allowTouchMove: false,
				autoplay:true,
				delay:200,
				speed:1000,
				effect: 'slide',
            })
            mySwiper.navigation.$nextEl.css('display','none');
            mySwiper.navigation.$prevEl.css('display','none');
        },

        computed: {
          

        },
    }
</script>

<style scoped>
    .slider_img {
        height: 490px;
        width: 100%;
        background-repeat: no-repeat;
        background-position:center
    }
    .banner{
        height: 490px;
        width: 100%;
        margin-top: 80px;

    }
    #swiperIndex.swiper-container{
	width: 100%;
    }
    @media screen {
        
    }
    .swiper-button-next{
        right:calc(50% - 930px) ;
        background:rgba(0,0,0,.1)
        

    }
    .swiper-button-prev{
        left:calc(50% - 930px);
        background:rgba(0,0,0,.1)

    }
    .swiper-wrapper .overlay {
      position: relative;
      margin: 115px auto;
      width: 1000px;
      height: 250px;
      background: linear-gradient(to right, rgba(0, 0, 0, 0), rgba(0, 0, 0, 0.7), rgba(0, 0, 0, 0));
      display: flex;
      justify-content: center;
      align-items: center;
    }
    .swiper-wrapper .text {
      color: #fff;
      font-size: 2em;
      position: absolute;
      text-align: center;
      h2 {
        font-size: 44px;
        font-weight: 600;
        margin-bottom: 30px;
        font-family:  'Helvetica Neue', Arial, sans-serif;
        letter-spacing: 2px;
      }
      p{
        font-size: 30px;
        letter-spacing: 2px;
        font-family: 'SimHei', 'SimSun', sans-serif;
        }
    }
    
</style>
